function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("line", {
  y1: 24,
  x2: 25,
  y2: 24,
  stroke: "#AAAAAA",
  strokeWidth: 2
}), React.createElement("line", {
  x1: 1,
  y1: 25,
  x2: 1,
  y2: 100,
  stroke: "#AAAAAA",
  strokeWidth: 2
}), React.createElement("line", {
  y1: 99,
  x2: 75,
  y2: 99,
  stroke: "#AAAAAA",
  strokeWidth: 2
}), React.createElement("line", {
  x1: 76,
  y1: 100,
  x2: 76,
  y2: 75,
  stroke: "#AAAAAA",
  strokeWidth: 2
}), React.createElement("line", {
  x1: 75,
  x2: 75,
  y2: 50,
  stroke: "#AAAAAA",
  strokeWidth: 10
}), React.createElement("line", {
  x1: 100.007,
  y1: 25,
  x2: 50.0069,
  y2: 25.0688,
  stroke: "#AAAAAA",
  strokeWidth: 10
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 100,
  height: 100,
  fill: "white"
})));

var SvgUploadIcon = function SvgUploadIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUploadIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload-icon.a989d960.svg";
export { ForwardRef as ReactComponent };